import { put } from 'redux-saga/effects'
import { actions as configActions } from 'src/features/config/ConfigSlice'

/**
 * Generator function that initializes configuration state in Redux
 *
 * @param {Object} configs - Object containing configuration data
 *
 * @returns {void}
 */
export function* initializeConfigState(configs) {
  // Save config to redux state
  for (const key of Object.keys(configs)) {
    let data = configs[key]

    if (key === 'menus' || !data) {
      continue
    }

    yield put(configActions.addConfigSuccess({ key, data }))
  }
  yield put(configActions.initialConfigSuccess())
}
